var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgAllfiles = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 17,
  height: 17,
  fill: "none",
  viewBox: "0 0 17 17"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "#000",
  clipPath: "url(#clip0_2069_4589)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M7.41 7.41H0V2.75C0 1.23 1.23 0 2.75 0h4.66zM1.5 5.91h4.41V1.5H2.75c-.69 0-1.25.56-1.25 1.25zM16.69 7.41H9.28V0h4.66c1.52 0 2.75 1.23 2.75 2.75zm-5.91-1.5h4.41V2.75c0-.69-.56-1.25-1.25-1.25h-3.16zM7.41 16.69H2.75C1.23 16.69 0 15.46 0 13.94V9.28h7.41zM1.5 10.78v3.16c0 .69.56 1.25 1.25 1.25h3.16v-4.41zM13.94 16.69H9.28V9.28h7.41v4.66c0 1.52-1.23 2.75-2.75 2.75m-3.16-1.5h3.16c.69 0 1.25-.56 1.25-1.25v-3.16h-4.41z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_2069_4589"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h16.69v16.69H0z"
})))));
export default SvgAllfiles;